module.exports = __webpack_public_path__ + "static/media/rotate.da4c6a2.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/rotate.wav
// module id = 156
// module chunks = 1